import GeneratedConstants from "./GeneratedConstants.json";

// NOTE: Declaration merging is used throughout this file to create pseudo-enums

export const Program = GeneratedConstants.Program;
export type Program = keyof typeof Program;

export const BankAccountOptions = GeneratedConstants.BankAccountOptions;
export type BankAccountOptions = keyof typeof BankAccountOptions;

export const PaymentMethodOptions = GeneratedConstants.PaymentMethodOptions;
export type PaymentMethodOptions = keyof typeof PaymentMethodOptions;

export const UnderwritingStrings = GeneratedConstants.SharedUnderwritingStrings;
export type UnderwritingStrings = keyof typeof UnderwritingStrings;

export const serverConstants = GeneratedConstants;
